import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {

  constructor(private httpClient: HttpClient) { }

  get<T>(endpoint: string, params: object = {}): Observable<T> {
    for (let k in params) 
      if ([undefined, null, ''].indexOf(params[k]) != -1) delete params[k];
    return this.httpClient.get<T>(
      endpoint + (
        Object.values(params).length ? '?'
        + Object.entries(params).map(([k, v]) => k + '=' + encodeURIComponent(v)).join('&')
        : ''),
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
    );
  }
}
